module.exports = __webpack_public_path__ + "img/bgc.f42d8f48.png";